import { styled } from '@mui/material/styles';
import { Typography } from '@mui/material';
import { fontFamilies } from '../../../../../constants/theme';
import { figmaLetterSpacing, Gapper } from '../../../../../ui/utils';
import { SectionHeading } from '../../../../../ui/typography';

export const Wrapper = styled(Gapper)(({ theme }) => ({
  alignItems: 'center',
  maxWidth: 900,
  margin: '0 auto',
  [theme.breakpoints.down('md')]: {
    padding: '0 20px',
  },
  [theme.breakpoints.down('sm')]: {
    padding: '0 16px',
  },
}));

export const Title = styled(SectionHeading)(({ theme }) => ({
  fontFamily: fontFamilies.gothamBook,
  fontWeight: 400,
  fontSize: '50px',
  lineHeight: '58px',
  letterSpacing: figmaLetterSpacing(50, -1),
  color: theme.palette.text.primary,
  textAlign: 'center',
  [theme.breakpoints.down('md')]: {
    fontSize: '36px',
    lineHeight: '44px',
    letterSpacing: figmaLetterSpacing(36, -1),
  },
  [theme.breakpoints.down('sm')]: {
    fontSize: '28px',
    lineHeight: '36px',
    letterSpacing: figmaLetterSpacing(28, -1),
  },
}));

export const Text = styled(Typography)(({ theme }) => ({
  fontFamily: fontFamilies.quicksand,
  fontWeight: 400,
  fontSize: '22px',
  lineHeight: '32px',
  letterSpacing: figmaLetterSpacing(22, 2),
  color: theme.palette.text.primary,
  textAlign: 'center',
  textWrap: 'balance',
  '& b': {
    fontWeight: 600,
  },
  [theme.breakpoints.down('lg')]: {
    fontSize: '20px',
  },
  [theme.breakpoints.down('md')]: {
    fontSize: '18px',
  },
  [theme.breakpoints.down('sm')]: {
    fontSize: '16px',
  },
}));

export const Image = styled('img')(({ theme }) => ({
  maxWidth: 836,
  maxHeight: 488,
  width: '100%',
  height: '100vh',
  objectFit: 'cover',
  borderRadius: 10,
  boxShadow:
    ' -4px -4px 17.8px 0px rgba(205, 214, 223, 0.15), 4px 4px 15px 0px rgba(205, 214, 223, 0.25)',
  [theme.breakpoints.down('md')]: {
    maxHeight: 350,
    borderRadius: 8,
  },
  [theme.breakpoints.down('sm')]: {
    maxHeight: 250,
  },
}));
